import { translate } from 'react-translate'
import BellNotificationFooter from './footer'
export default translate('BellNotification')(BellNotificationFooter)
